<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <Dirigentes style="height: 100%;"/>
    </div>
</template>

<script>
import Dirigentes from '../components/Dirigentes/Dirigentes'
export default {
  components: {
    Dirigentes
  }
}
</script>
